import { range } from "lodash";
import Skeleton from "react-loading-skeleton";

interface ThemesLoadingSkeletonProps {
  count?: number;
}

const ThemesLoadingSkeleton = ({ count = 4 }: ThemesLoadingSkeletonProps) => {
  return (
    <main className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {range(count).map((item) => (
        <Skeleton key={item} className="aspect-square" borderRadius={8} />
      ))}
    </main>
  );
};

export default ThemesLoadingSkeleton;
